import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from 'vue-router'

const routes = [{
		path: '/',
		redirect: '/download',
	},
	{
		path: '/video',
		component: () => import( /* webpackChunkName: "about" */ '../views/video/index.vue')
	},
	{
		path: '/download',
		component: () => import( /* webpackChunkName: "about" */ '../views/download.vue')
	},
	{
		path: '/guide',
		component: () => import( /* webpackChunkName: "about" */ '../views/guide.vue')
	},
	{
		path: '/downloadl',
		component: () => import( /* webpackChunkName: "about" */ '../views/downloadl.vue')
	},
	// 新的APP隐私和服务协议
	{
		path: '/agreement/agreement/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/agreement/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/agreement/giveservice',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/agreement/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 新的公众号隐私和服务协议
	{
		path: '/agreement/officialAccount/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/officialAccount/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/officialAccount/giveservice',
		component: () => import( /* webpackChunkName: "about" */
			'../views/agreement/officialAccount/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	/**
	 * APP 
	 */
	{
		path: '/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/app/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/giveservice',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/app/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 乐恒APP
	{
		path: '/agreement/app/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/app/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/app/giveservice',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/app/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 乐恒智慧农业
	{
		path: '/agreement/leheng/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/leheng/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/leheng/giveservice',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/leheng/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 农小二APP
	{
		path: '/agreement/nongxiaoer/privacy',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/nongxiaoer/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/nongxiaoer/giveservice',
		component: () => import( /* webpackChunkName: "about" */ '../views/agreement/nongxiaoer/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 公众号目前使用largeGreenhouse
	/**
	 * mobile 
	 */
	// 四情
	{
		path: '/agreement/mobile/fourEmotions/privacy',
		component: () => import( /* webpackChunkName: "about" */
			'../views/agreement/mobile/fourEmotions/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/mobile/fourEmotions/giveservice',
		component: () => import( /* webpackChunkName: "about" */
			'../views/agreement/mobile/fourEmotions/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
	// 大棚
	{
		path: '/agreement/mobile/largeGreenhouse/privacy',
		component: () => import( /* webpackChunkName: "about" */
			'../views/agreement/mobile/largeGreenhouse/privacy.vue'),
		meta: {
			title: '隐私协议'
		}
	},
	{
		path: '/agreement/mobile/largeGreenhouse/giveservice',
		component: () => import( /* webpackChunkName: "about" */
			'../views/agreement/mobile/largeGreenhouse/giveservice.vue'),
		meta: {
			title: '服务协议'
		}
	},
]

const router = createRouter({
	history: createWebHistory('/download/'),
	// history: createWebHashHistory(process.env.BASE_URL),
	routes
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title || '乐恒智慧农业';
	next();
});

export default router